
import React, { useEffect, useState } from "react";

export default function Custom404() {
  const [stage, setStage] = useState("enter"); // enter → idle → dance

  useEffect(() => {
    // ENTRY → IDLE → DANCE LOOP
    const sequence = () => {
      setStage("enter");

      setTimeout(() => setStage("idle"), 800);      // smooth entry
      setTimeout(() => setStage("dance"), 3800);    // 3 sec pause then dance
      setTimeout(sequence, 7600);                   // return & repeat
    };

    sequence();
  }, []);

  // Random dance positions
  const randomDance = () => ({
    transform: `translate(${Math.random() * 40 - 20}px, ${
      Math.random() * 40 - 20
    }px) rotate(${Math.random() * 20 - 10}deg)`
  });

  return (
    <div className="w-full h-screen flex flex-col items-center justify-center rounded-t bg-theme-bg overflow-hidden relative">

      {/* 404 NUMBERS */}
      <div className="flex gap-4 text-[120px] md:text-[100px] font-bold  relative">

        {/* FIRST 4 */}
        <span
          style={stage === "dance" ? randomDance() : {}}
          className={`
            transition-all duration-700 ease-out text-theme-sidebarBg font-serif
            ${stage === "enter" ? "-translate-x-0 -translate-y-0 opacity-80 rotate-10" : ""}
            ${stage === "idle" ? "translate-x-0 translate-y-0 opacity-100 rotate-0" : ""}
          `}
        >
          Coming
        </span>

        {/* 0 */}
        <span
          style={stage === "dance" ? randomDance() : {}}
          className={`
            transition-all duration-700 ease-out  text-black font-serif
            ${stage === "enter" ? "-translate-y-0 opacity-80" : ""}
            ${stage === "idle" ? "translate-y-0 opacity-100" : ""}
          `}
        >
          Soon
        </span>

        {/* LAST 4 */}
        {/* <span
          style={stage === "dance" ? randomDance() : {}}
          className={`
            transition-all duration-700 ease-out text-theme-sidebarBg font-serif
            ${stage === "enter" ? "translate-x-0 -translate-y-0 opacity-80 -rotate-12" : ""}
            ${stage === "idle" ? "translate-x-0 translate-y-0 opacity-100 rotate-0" : ""}
          `}
        >
          4
        </span> */}
      </div>

      {/* TEXT */}
      <p className="text-xl md:text-2xl text-black mt-4 animate-bounce">
        Oops! Page not found.
      </p>

      {/* BUTTON */}
      <a href="/" className="bg-theme-sidebarBg px-2 py-1 rounded text-white no-underline mt-6 hover:shadow-theme-sidebarBg shadow-blue-500/40">
        Go Home
      </a>

      {/* FLOATING BG CIRCLES */}
      <div className="absolute top-10 left-10 w-10 h-10 bg-white/40 rounded-full animate-ping"></div>
      <div className="absolute bottom-24 right-20 w-14 h-14 bg-white/30 rounded-full animate-pulse"></div>
      <div className="absolute top-1/3 right-5 w-8 h-8 bg-white/50 rounded-full animate-bounce"></div>
    </div>
  );
}
